<template>
    <transition name="fade">
        <div class="patient-coaching-summary-path">

            <b-row>
                <b-col cols="3" class="text-center">
                    <label>{{ $i18n.gt('LABEL_PATH_VISION') }}</label>
                </b-col>
                <b-col cols="1" class="pb-2"
                       v-if="showEditLinks">
                    <my-path-edit-modal :title="$i18n.gt('LABEL_EDIT_VISION')"
                                        :info-text="$i18n.gt('LABEL_EDIT_VISION_PROMPT')"
                                        :path="path"
                                        field="vision">
                    </my-path-edit-modal>
                </b-col>
                <b-col :cols="showEditLinks ? 7 : 8" class="pb-2">
                    {{ path.vision }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3" class="text-center">
                    <label>{{ $i18n.gt('LABEL_PATH_VALUES') }}</label>
                </b-col>
                <b-col cols="1" class="pb-2"
                       v-if="showEditLinks">
                    <my-path-edit-modal :title="$i18n.gt('LABEL_EDIT_VALUES')"
                                        :info-text="$i18n.gt('LABEL_EDIT_VALUES_PROMPT')"
                                        :path="path"
                                        field="values">
                    </my-path-edit-modal>
                </b-col>
                <b-col :cols="showEditLinks ? 7 : 8" class="pb-2">
                    {{ path.values }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3" class="text-center">
                    <label>{{ $i18n.gt('LABEL_PATH_CONFIDENCE') }}</label>
                </b-col>
                <b-col cols="1" class="pb-2"
                       v-if="showEditLinks">
                    <my-path-edit-modal :title="$i18n.gt('LABEL_EDIT_CONFIDENCE')"
                                        :info-text="$i18n.gt('LABEL_EDIT_CONFIDENCE_PROMPT')"
                                        :path="path"
                                        field="confidence">
                    </my-path-edit-modal>
                </b-col>
                <b-col :cols="showEditLinks ? 7 : 8" class="pb-2">
                    {{ path.confidence }}
                </b-col>
            </b-row>

        </div>
    </transition>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'PatientCoachingSummaryPath',
    props: {
        showEditLinks: {type: Boolean, default: false}
    },
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        path() {
            return this.participant.wellness_plan ? this.participant.wellness_plan.path : {}
        },
    }
})
</script>
